import React, {useEffect} from 'react';
import {useParams} from 'react-router-dom';
import {useGetPollInfo} from './useGetPollList';

export const PollDetails = () => {
  const {pollId} = useParams();
  const {
    downloadingPollInfoErrorMsg,
    downloadingPollInfoStatus,
    getPollInfo,
    pollStats,
  } = useGetPollInfo({mode: 'pollStats', pollId: pollId});

  useEffect(() => {
    getPollInfo();
  });

  const tableColumns = [
    {label: 'Answer', accessor: 'title'},
    {label: 'Percentage', accessor: 'percentageBreakdown'},
    {label: 'Overall Score', accessor: 'overallScore'},
  ];

  const dataRankedByHighestPercentage =
    pollStats &&
    [...pollStats.pollResults].sort(
      (a, b) => b.percentageBreakdown - a.percentageBreakdown,
    );

  if (downloadingPollInfoStatus === 'requesting') {
    return <span className="loading loading-spinner loading-sm" />;
  }
  if (downloadingPollInfoStatus === 'error') {
    return (
      <div>
        <p className="text-red-600">Error:</p>
        <p>{downloadingPollInfoErrorMsg}</p>
      </div>
    );
  }
  return (
    <div className="p-5 mx-5">
      <h1 className="text-5xl text-center font-semibold">
        {pollStats && pollStats.title}
      </h1>
      <p className="pt-2 text-center">{pollStats && pollStats.shortDescr}</p>{' '}
      <p>
        <b>Type: </b>
        {pollStats && pollStats.selectionType === 'rank-items'
          ? 'Ranking'
          : 'Single Choice'}
      </p>
      <p>
        <b>Open Date:</b> {pollStats && pollStats.openDate}
      </p>
      <p>
        <b>Close Date:</b> {pollStats && pollStats.closeDate}
      </p>
      <p>
        <b>Evergreen?:</b>{' '}
        {pollStats && pollStats.evergreen === true ? 'Yes' : 'No'}
      </p>
      <div className="pt-3">
        <h3 className="text-xl font-bold">Poll Results</h3>
        <table className="table ">
          <thead>
            <tr>
              {tableColumns.map(({label, accessor}) => {
                return <th key={accessor}>{label}</th>;
              })}
            </tr>
          </thead>
          <tbody>
            {dataRankedByHighestPercentage &&
              dataRankedByHighestPercentage.map((result, i) => {
                return (
                  <tr key={result.optionId}>
                    <td>{result.title}</td>
                    <td>{`${result.percentageBreakdown.toFixed(2)}%`}</td>
                    <td>{result.overallScore}</td>
                  </tr>
                );
              })}
          </tbody>
        </table>
      </div>
    </div>
  );
};
